export default "__VITE_ASSET__a01eb2ef__"